module.exports = __webpack_public_path__ + "img/con3_mockup.7de27b1a.jpg";